import { VuetifyThemeVariant } from 'vuetify/types/services/theme';

export const stateThemeTokens: Partial<VuetifyThemeVariant> = {
  draft: '#9E9E9E',
  submitted: '#FFC107',
  approved: '#8BC34A',
  reject: '#D32F2F',
  cancel: '#FF5722',
  done: '#4CAF50',
  closed: '#388E3C'
};
export const lightTheme: Partial<VuetifyThemeVariant> = {
  primary: '#002677',
  secondary: '#FFB81C',
  background: '#F2F2F2',
  accent: '#82B1FF',
  error: '#DE3730',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  ...stateThemeTokens
};
export const darkTheme: Partial<VuetifyThemeVariant> = {
  primary: '#002677',
  secondary: '#FFB81C',
  background: '#F2F2F2',
  accent: '#82B1FF',
  error: '#DE3730',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  ...stateThemeTokens
};
